import React from "react";
import Quiz from "./components/quiz";
import Welcome from "./components/welcome";
import Instructions from "./components/instructions";
import Results from "./components/results";
import Reward from "./components/reward";

export const routes = [
  { path: '/quiz-klimatyczny/', component: <Welcome /> },
  { path: '/quiz-klimatyczny/instructions', component: <Instructions />},
  { path: '/quiz-klimatyczny/quiz', component: <Quiz />},
  { path: '/quiz-klimatyczny/results', component: <Results />},
  { path: '/quiz-klimatyczny/reward', component: <Reward />}
];

export default routes;